import { useSettings } from '@app/ui/core/settings/use-settings';
import {Helmet} from './helmet';
import {ReactElement} from 'react';

type TitleChild = string | ReactElement<any> | any;
export type TitleMetaTagChildren = TitleChild | TitleChild[];

interface StaticPageTitleProps {
  children: TitleMetaTagChildren;
}
export function StaticPageTitle({children}: StaticPageTitleProps) {
  const {
    branding: {site_name},
  } = useSettings();
  return (
    <Helmet>
      {children ? (
        // @ts-ignore
        <title>
          {children} - {site_name}
        </title>
      ) : undefined}
    </Helmet>
  );
}
